import React, { useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";

function CreaEquipoCuidadoIntensivo({ idSolicitud, onCreated }) {
  const [modalIsOpen, setIsOpen] = useState(false);

  const [nombre, setNombre] = useState("");
  const [servicio, setServicio] = useState("");
  const [cargo, setCargo] = useState("");
  const [lider, setLider] = useState("");

  const postData = async (e) => {
    e.preventDefault();

    try {
      await axios({
        method: "post",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url: "https://suadesarrollo.azurewebsites.net/api/CreaEquipoCuidados",
        data: {
          nombre,
          servicio,
          cargo,
          lider,
          SolicitudId: idSolicitud,
        },
      });

      // ✅ refresca tabla
      onCreated();

      // ✅ limpiar formulario
      setNombre("");
      setServicio("");
      setCargo("");
      setLider("");

      // ✅ cerrar modal
      setIsOpen(false);

      alert("Añadido con éxito");
    } catch (error) {
      console.error(error);
      alert("Error al crear el equipo");
    }
  };

  return (
    <>
      <button className="btn btn-primary" onClick={() => setIsOpen(true)}>
        Nueva
      </button>

      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={() => setIsOpen(false)}
        ariaHideApp={false}
      >
        <div className="container">
          <div className="card shadow">
            <div className="card-header py-3">
              <h6 className="m-0 font-weight-bold text-primary">
                Crear EQUIPO PRIMARIO DE MEJORAMIENTO DE CUIDADOS INTENSIVOS
              </h6>
            </div>

            <div className="card-body">
              <form onSubmit={postData}>
                <div className="form-group">
                  <input
                    className="form-control"
                    placeholder="Nombre"
                    value={nombre}
                    onChange={(e) => setNombre(e.target.value)}
                    required
                  />
                </div>

                <div className="form-row">
                  <div className="form-group col-md-6">
                    <input
                      className="form-control"
                      placeholder="Servicio"
                      value={servicio}
                      onChange={(e) => setServicio(e.target.value)}
                      required
                    />
                  </div>

                  <div className="form-group col-md-6">
                    <input
                      className="form-control"
                      placeholder="Cargo"
                      value={cargo}
                      onChange={(e) => setCargo(e.target.value)}
                      required
                    />
                  </div>
                </div>

                <div className="form-group">
                  <select
                    className="form-control"
                    value={lider}
                    onChange={(e) => setLider(e.target.value)}
                    required
                  >
                    <option value="">¿Es líder?</option>
                    <option value="Si">Sí</option>
                    <option value="No">No</option>
                  </select>
                </div>

                <div className="d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => setIsOpen(false)}
                  >
                    Cancelar
                  </button>

                  <button type="submit" className="btn btn-primary">
                    Guardar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}

export default CreaEquipoCuidadoIntensivo;
